import ACTIONS from "../actions/BillingGroupPricingActions";
import _ from "lodash";

const initialState = {

    // Modals
    showModalBGPricingScheme: false,
    showModalBGCountryPricing: false,
    showModalEditBGCountryPricing: false,

    // $$$ Warnings to rename
    deleteCountryPriceWarning: false,
    addPricingSchemeModalOpen: false,
    countryPricingIDForDelete: "",

    pricingTables: {},

    pricingTableObjectV2: {
        name: "",
        description: "",
        currency: "USD",
        pricing_type: "TENANT",
        volume_aggregation_period: "MONTHLY",
        volume_aggregation_type: "",
        updated_by: "",
        base_price: 0,
    },

    countryPriceObject: {
        price: "",
        countries: [],
        pricing_id: "",
        add: false,
        original_price: ""
    },

    pricingSchemeObject: {
        country_code: "",
        country_pricing_id: "",
        billing_group_id: "",
        pricing_json: [],
        pricing_scheme: ""
    },

    pricingSchemeOptions: [
        { label: "FLAT", value: "FLAT" },
        { label: "VOLUME", value: "VOLUME" },
        { label: "TIERED", value: "TIERED" }
    ],
}

export default function billingGroupPricingReducer(state = initialState, action) {

    switch (action.type) {

        // Modals
        case ACTIONS.BGPricingActionTypes.TOGGLE_ADD_MODAL_BG_PRICING_SCHEME: {
            let newState = _.cloneDeep(state);
            newState.showModalBGPricingScheme = !newState.showModalBGPricingScheme;
            if (action.payload.billingGroupID !== "") {
                newState.pricingSchemeObject.billing_group_id = action.payload.billingGroupID;
                newState.pricingSchemeObject.pricing_json.push({ min: 0, max: 0, price: 0 });
            } else {
                newState = initialState;
            }

            return newState;
        }

        case ACTIONS.BGPricingActionTypes.TOGGLE_ADD_BG_COUNTRY_PRICING_MODAL: {
            let newState = _.cloneDeep(state);
            const { billingGroupID, pricingScheme, pricingJsonKey } = action.payload;
            newState.showModalBGCountryPricing = !newState.showModalBGCountryPricing;
            if (newState.showModalBGCountryPricing) {
                newState.pricingSchemeObject.billing_group_id = billingGroupID;
                newState.pricingSchemeObject.pricing_scheme = pricingScheme;
                if (pricingScheme === 'FLAT') {
                    newState.pricingSchemeObject.pricing_json.push({min: 0 , max: null, price: 0});
                } else {
                    newState.pricingSchemeObject.pricing_json = pricingJsonKey;
                    newState.pricingSchemeObject.pricing_json.forEach(p => {
                        p.price = 0;
                    });
                }

            } else {
                newState.pricingSchemeObject = initialState.pricingSchemeObject;
            }

            return newState
        }

        case ACTIONS.BGPricingActionTypes.TOGGLE_EDIT_BG_COUNTRY_PRICING_MODAL: {
            let newState = _.cloneDeep(state);
            newState.pricingSchemeObject = action.payload;
            newState.showModalEditBGCountryPricing = !newState.showModalEditBGCountryPricing;

            return newState
        }

        case ACTIONS.BGPricingActionTypes.CLOSE_MODAL_BG_COUNTRY_PRICING: {
            return initialState;
        }

        // Form handlers
        case ACTIONS.BGPricingActionTypes.SELECT_BG_PRICING_FORM_SCHEME: {
            let newState = _.cloneDeep(state);
            if (action.payload.pricingScheme !== null) {
                newState.pricingSchemeObject.pricing_scheme = action.payload.pricingScheme.value;
                if (action.payload.pricingScheme.value === "FLAT") {
                    // reset the json and add the flat-default tier
                    newState.pricingSchemeObject.pricing_json = [];
                    newState.pricingSchemeObject.pricing_json.push({ min: 0, max: null, price: 0 });
                }
            } else {
                newState.pricingSchemeObject.pricing_scheme = "";
            }

            return newState;
        }

        case ACTIONS.BGPricingActionTypes.SELECT_BG_PRICING_FORM_COUNTRY: {
            let newState = _.cloneDeep(state);

            if (action?.payload?.country !== null) {
                newState.pricingSchemeObject.country_code = action.payload.country.value;
            } else {
                newState.pricingSchemeObject.country_code = "";
            }
            return newState;

        }


        case ACTIONS.BGPricingActionTypes.SET_BG_PRICING_FORM_FLAT_PRICE: {
            let newState = _.cloneDeep(state);
            if (action?.payload?.value === "") {
                newState.pricingSchemeObject.pricing_json[0].price = "";
            }
            else {
                newState.pricingSchemeObject.pricing_json[0].price = Number(action.payload.value);
            }
            return newState;
        }


        case ACTIONS.BGPricingActionTypes.ADD_BG_PRICING_FORM_VOLUME_TIER: {
            let newState = _.cloneDeep(state);
            // const idx = action.payload;
            const currTierNumber = newState.pricingSchemeObject.pricing_json.length - 1;
            let prevMax = newState.pricingSchemeObject.pricing_json[currTierNumber].max;
            newState.pricingSchemeObject.pricing_json.push({ min: prevMax + 1, max: null, price: 0 });

            return newState;
        }

        case ACTIONS.BGPricingActionTypes.SET_BG_PRICING_FORM_VOLUME_TIER: {
            let newState = _.cloneDeep(state);
            const { value, name, idx } = action.payload;
            if (value === "") {
                newState.pricingSchemeObject.pricing_json[idx][name] = "";
            } else {
                newState.pricingSchemeObject.pricing_json[idx][name] = Number(value);
            }

            return newState;
        }

        case ACTIONS.BGPricingActionTypes.DELETE_BG_PRICING_FORM_VOLUME_TIER: {
            let newState = _.cloneDeep(state);
            // only deletes the last volume tier in the pricing_json
            newState.pricingSchemeObject.pricing_json = newState.pricingSchemeObject.pricing_json.slice(0, -1);

            return newState;
        }

        case ACTIONS.BGPricingActionTypes.DELETE_BG_PRICING_WARNING: {
            let newState = _.cloneDeep(state);

            newState.deleteCountryPriceWarning = !newState.deleteCountryPriceWarning;
            newState.countryPricingIDForDelete = action.payload;

            return newState;
        }

        default:
            return state;
    }
}
